const initialState = () => {
    return {
        cashAmount: '',
        comment: '',
        showModal: false,
        date: '', // date + time string (just to show, it's not a data that will be sent to the backend)
        arqueoData: null,
        initialSummaries: null,
        invoicesData: null,
    }
}

export default initialState
